/**
 * Created on Fri Jun 12 2026 4:08:23 PM
 *
 * *************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2026
 * All Rights Reserved
 *
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ************************************************************************************/


import { validateElementLayout, validateReferenceWidth } from './layoutCore';

const REQUIRED_FIELDS = ['x', 'y', 'width', 'height', 'z'];

export const SKIP_INCOMPLETE = 'incomplete';
export const SKIP_INVALID = 'invalid';

export function classifyEntry(raw) {
  if (raw === null || typeof raw !== 'object') {
    return { ok: false, reason: SKIP_INVALID };
  }

  const result = validateElementLayout(raw);
  if (result.ok) {
    return { ok: true, value: result.value };
  }

  const missingRequired = REQUIRED_FIELDS.some((field) => raw[field] === undefined);
  return { ok: false, reason: missingRequired ? SKIP_INCOMPLETE : SKIP_INVALID };
}

export function partitionElementLayout(elements) {
  const entries = {};
  const skipped = {};

  if (elements === null || typeof elements !== 'object') {
    return { entries, skipped };
  }

  for (const elementId of Object.keys(elements)) {
    const classified = classifyEntry(elements[elementId]);
    if (classified.ok) {
      entries[elementId] = classified.value;
    } else {
      skipped[elementId] = classified.reason;
    }
  }

  return { entries, skipped };
}

export function resolveSectionLayout(section) {
  if (!section || typeof section !== 'object') return null;

  const layout = section.layout;
  if (!layout || typeof layout !== 'object') return null;

  const elementLayout = layout.elementLayout;
  if (!elementLayout || typeof elementLayout !== 'object') return null;

  const rw = validateReferenceWidth(elementLayout.referenceWidth);
  if (!rw.ok) return null;

  const { elements } = elementLayout;
  if (!elements || typeof elements !== 'object') return null;

  const { entries, skipped } = partitionElementLayout(elements);

  if (Object.keys(entries).length === 0) return null;

  return { referenceWidth: rw.value, entries, skipped };
}
